module.exports = __webpack_public_path__ + "public/images/stand-bg.5038adf26d273a27d0e459a4bebda011.webp";